export enum PaymentType {
  PAGO,
  RESERVA,
  PHONEANDSELL,
  MODIFICARRESERVA
}
